import dayjs from 'dayjs'
import {
  ID_PRESUPUESTO_CONFIRMADO,
  ID_PRESUPUESTO_EN_PREPARACION,
  ID_PRESUPUESTO_PAGADO,
  ID_PRESUPUESTO_PENDIENTE
} from '../constants/presupuesto.js'

const COLOR_POR_ESTADO = {
  [ID_PRESUPUESTO_PENDIENTE]: 'warning',
  [ID_PRESUPUESTO_CONFIRMADO]: 'success',
  [ID_PRESUPUESTO_PAGADO]: 'success',
  [ID_PRESUPUESTO_EN_PREPARACION]: 'info'
}

export const esPresupuestoVencido = (idEstado, fechaValidez) => {
  if (idEstado !== ID_PRESUPUESTO_CONFIRMADO || !fechaValidez) {
    return false
  }
  const fecha = dayjs(fechaValidez)
  return fecha.isValid() && fecha.isBefore(dayjs(), 'day')
}

export const obtenerEstadoVisual = ({ idEstado, estado, fechaValidez }) => {
  if (esPresupuestoVencido(idEstado, fechaValidez)) {
    return { color: 'danger', label: 'Vencido' }
  }

  return { color: COLOR_POR_ESTADO[idEstado] ?? 'secondary', label: estado }
}
